import React from 'react'
import get from 'lodash/get'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Image from 'constructicon/lazy-image'
import RichText from '../../ui/RichText'
import Section from '../../ui/Section'

const QRCode = ({
  alignment,
  background,
  classNames,
  copy,
  foreground,
  fundraisingPage,
  spacing,
  styles
}) => {
  const imageUrl = get(fundraisingPage, 'qrCodes[0].url') || fundraisingPage.donateQrCodeImage

  return (
    <Section
      alignment={alignment}
      background={background}
      foreground={foreground}
      spacing={spacing}
    >
      {copy && <RichText>{copy}</RichText>}
      {imageUrl && (
        <div className={classNames.wrapper}>
          <Image url={imageUrl} styles={styles.image} />
        </div>
      )}
    </Section>
  )
}

export default withStyles(styles)(QRCode)
